import {
    ADJUSTMENTS_GET_REQUEST,
    ADJUSTMENTS_POST_REQUEST,
    ADJUSTMENTS_BY_ID_GET_REQUEST,
    ADJUSTMENTS_BY_ID_DELETE_REQUEST,
    ADJUSTMENTS_UPDATED,
    APPLIED_DISCOUNTS_GET_REQUEST,
} from '../actionTypes/AdjustmentActionTypes';

const getAdjustments = (payload) => ({
    type: ADJUSTMENTS_GET_REQUEST,
    payload,
});

const applyAdjustment = (payload) => ({
    type: ADJUSTMENTS_POST_REQUEST,
    payload,
});

const getAdjustmentDetailById = (payload) => ({
    type: ADJUSTMENTS_BY_ID_GET_REQUEST,
    payload,
});

const removeAdjustmentById = (payload, couponAnimation, selectedCouponCode) => ({
    type: ADJUSTMENTS_BY_ID_DELETE_REQUEST,
    payload,
    couponAnimation,
    selectedCouponCode,
});

const adjustmentUpdated = (payload) => ({
    type: ADJUSTMENTS_UPDATED,
    payload,
});

const getAppliedDiscounts = (payload) => ({
    type: APPLIED_DISCOUNTS_GET_REQUEST,
    payload,
});

export default {
    getAdjustments,
    applyAdjustment,
    getAppliedDiscounts,
    getAdjustmentDetailById,
    removeAdjustmentById,
    adjustmentUpdated,
};
